
import Vue from "vue";
import AppCustomTable from "@/components/common/CustomTable.vue";
import AppSidebarKeyValueList, { ISidebarKeyValueRow } from "./SidebarKeyValueList.vue";
import { BrowseStateBase } from "@/utils/browse/browse-state-base";
import { printHumanFloat } from "@/utils/pretty-print";

export default Vue.extend({
	props: {
		item: {
			type: Object as () => any,
			required: true
		},
		state: {
			type: Object as () => BrowseStateBase,
			required: true
		}
	},
	computed: {
		loaded():boolean {
			return this.state.sidebarItemLoaded;
		},
		rows():any[] {
			return this.item.Rows || [];
		},
		contactName():string {
			let contact = this.item.Contact;
			if (!contact || !contact.ID) return "";
			let address = contact.MainAddress;
			if (address && address.CompanyOrFullName) return address.CompanyOrFullName;
			return contact.ComputedFriendlyID || "";
		},
		headerRows():ISidebarKeyValueRow[] {
			if (!this.contactName) return [];
			return [{label: this.$ct("sidebar.sale-rows.contact").toString(), value: this.contactName}];
		},
		totalRows():ISidebarKeyValueRow[] {
			let t = (key:string)=>this.$ct(`sidebar.sale-rows.${key}`).toString();
			return [
				{label: t("total-exc-vat"), value: printHumanFloat(this.item.TotalExcVAT || 0, 2), right: true},
				{label: t("total-inc-vat"), value: printHumanFloat(this.item.TotalIncVAT || 0, 2), right: true},
				{label: t("to-pay"), value: printHumanFloat(this.item.TotalToPay || 0, 2), right: true, warning: (this.item.TotalToPay || 0) > 0}
			];
		},
		summary():string {
			return this.$ctc("sidebar.sale-rows.count", this.rows.length, {count: this.rows.length}).toString();
		}
	},
	watch: {
		summary: {
			immediate: true,
			handler(){
				this.$emit("summary", this.summary);
			}
		},
		item(){
			this.$emit("summary", this.summary);
		}
	},
	methods: {
		description(row:any):string {
			return row.ProductDescriptionStripped || row.ProductDescription || "";
		},
		printAmount(value:number):string {
			return printHumanFloat(value || 0, 2).replace(/[,.]00$/, "");
		},
		printFloat(value:number):string {
			return printHumanFloat(value || 0, 2);
		}
	},
	components: {
		AppCustomTable,
		AppSidebarKeyValueList
	},
	i18nEx: {
		componentPrefix: "components.browse"
	}
});
